import { render, staticRenderFns } from "./BusinessUnitTypeSelectBox.vue?vue&type=template&id=0a19fac2&scoped=true&"
import script from "./BusinessUnitTypeSelectBox.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitTypeSelectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a19fac2",
  null
  
)

export default component.exports